module.exports = __webpack_public_path__ + "static/media/up_icon.52a3e85e.svg";